export default {
  'software.poweredBy': 'Powered by',
  'copyright': 'Copyright',
  'allRightsReserved': 'All rights reserved',
};